module.exports = __webpack_public_path__ + "static/media/3. Alambre3, Mixta sobre madera, 122 x 94 cm, 2019 copy.c3d3110d.png";